/**
 * The signed-in gym's free trial (my_trial, migration 20261020000400) and removing its
 * sample data (remove_sample_data, 20261020000300). Normal gyms answer { is_trial: false }.
 */
import { unwrap } from '@gymcoach/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { supabase } from '@/lib/supabase';

export interface MyTrial {
  is_trial: boolean;
  ends_at?: string;
  /** Calendar days left in the gym's timezone; 0 = it ends today. */
  days_left?: number;
  has_sample_data?: boolean;
}

export const trialKeys = { mine: () => ['trial', 'mine'] as const };

export function useMyTrial() {
  return useQuery({
    queryKey: trialKeys.mine(),
    queryFn: async () => unwrap(await supabase.rpc('my_trial')) as unknown as MyTrial,
    staleTime: 10 * 60_000,
  });
}

export interface RemovedSample {
  members?: number;
  trainers?: number;
}

export function useRemoveSampleData() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => unwrap(await supabase.rpc('remove_sample_data')) as unknown as RemovedSample,
    // Every list in the CRM held sample people: start again from the server.
    onSuccess: () => queryClient.invalidateQueries(),
  });
}
